import { defineStore } from "pinia";
import http from '@/services/http.js'
import { api } from "@/services/api";

export const AuthStore = defineStore('auth', {
  state() {
    return {
      token: localStorage.getItem('token'),
      user: (localStorage.getItem('user') != undefined ? JSON.parse(localStorage.getItem('user')) : {}),
      isAuth: false,
      type_access: null,
      data_fim_acesso: null,
      // user: JSON.parse(localStorage.getItem('user')),
    }
  },
  actions: {
    setToken(tokenValue) {
      localStorage.setItem('token', tokenValue);
      this.token = tokenValue;
    },
    setUser(userValue) {
      localStorage.setItem('user', JSON.stringify(userValue));
      this.user = userValue;
    },
    setIsAuth(auth) {
      this.isAuth = auth;
    },
    estaLogado() {
      try {
        this.checkToken()
        return this.token && this.user;
      } catch (error) {
        this.clear()
      }
    },
    dataValidade() {
      if (this.data_fim_acesso) {
        const data_fim = this.data_fim_acesso.split('-');
        var data = new Date(data_fim[0], data_fim[1], data_fim[2]);

        return (data >= new Date())
      } else {
        return false
      }
    },
    async checkToken() {
      try {
        const tokenAuth = 'Bearer ' + localStorage.getItem('token');
        const { data } = await http.get('/login/verify', {
          headers: {
            Authorization: tokenAuth
          },
        });
        this.type_access = data.type_access;
        this.data_fim_acesso = data.fim_acesso;
        return data;
      } catch (error) {
        this.type_access = null;
        this.data_fim_acesso = null;
        return false
      }
    },
    async renewToken() {
      try {
        const tokenAuth = 'Bearer ' + this.token;
        const data = await api.get('/login/renewToken', { Authorization: tokenAuth });
        this.setToken(data.token)
        this.setUser(data.user)
        this.type_access = data.type_access;
        this.data_fim_acesso = data.fim_acesso;
        return data;
      } catch (error) {
        return false
      }
    },
    clear() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.token = ''
      this.type_access = null
      this.data_fim_acesso = null
      this.user = ''
    }
  },

  getters: {
    nomeUser() {
      if (this.user.nome) {
        var u = this.user.nome.split(" ")
        return "Bem vindo(a) " + u[0]
      } else {
        return ''
      }
    },
    acessoUser() {
      if (this.user.acesso) {
        return this.user.acesso
      } else {
        return ''
      }
    },
    nomeUserCompleto() {
      if (this.user) {
        return this.user.nome
      } else {
        return ''
      }
    },
    // token() { return localStorage.getItem('token') },
    //   // user: (localStorage.getItem('user') != undefined ? JSON.parse(localStorage.getItem('user')) : {}),
    // user() { return JSON.parse(localStorage.getItem('user')) },
  },
})